export default {
  props: {
    iconSize: {
      type: String,
      default: '18',
    }
  }
}
